import { Link } from 'react-router-dom';
import GameInfo, { TGameInfo } from './components/GameInfo';
import QbLogoFullName from '../Icons/QbLogoFullName';
import MenuButton from './components/Menu/components/MenuButton';
import useMenu from '../../hooks/useMenu';

type Props = {
  gameInfo?: TGameInfo;
};

const Header = ({ gameInfo }: Props) => {
  const { setOpen } = useMenu();
  return (
    <header className="flex flex-row items-center justify-between p-3">
      <Link to="/">
        <QbLogoFullName />
      </Link>
      <div className="flex flex-row gap-1">
        <GameInfo gameInfo={gameInfo} />
        <MenuButton onClick={setOpen} />
      </div>
    </header>
  );
};

export default Header;
